<template>
    <crud-create :open="open"
                 :loading="loading"
                 :title="title"
                 :errorMessage="errorMessage"
                 @create="create"
                 @close="$emit('close')"
    >
        <convenio-form ref="form" v-model="form" :input-errors="inputErrors" @save="create"
                       auto-select-deudas auto-select-cobranzas
                       :deudas-not-selectable="deudasNotSelectable"
                       :cobranzas-not-selectable="cobranzasNotSelectable"
                       :disableFields="disableFields" />
    </crud-create>
</template>

<script>

    import ConvenioProvider from "../../../../providers/ConvenioProvider";

    import {CrudCreate, ClientError} from '@dracul/common-frontend'

    import ConvenioForm from "../../../../forms/ConvenioForm";

    export default {
        name: "ConvenioCreate",

        components: { ConvenioForm, CrudCreate },

        props:{
          open: {type: Boolean, default: true},
          disableFields: {type: Array, default: () => []},
          cuilDeudor: {type: String, required: false},
          dniDeudor: {type: String, required: false},
          deudasNotSelectable: {type: Array, default: () => []},
          cobranzasNotSelectable: {type: Array, default: () => []},
        },
      created() {
          if(this.cuilDeudor){
            this.form.cuilDeudor = this.cuilDeudor
          }
          if(this.dniDeudor){
            this.form.dniDeudor = this.dniDeudor
          }
      },
      data() {
            return {
                title: 'cobrox.convenio.creating',
                errorMessage: '',
                inputErrors: {},
                loading: false,
                form: {
                    dniDeudor: '',
                    cuilDeudor: '',
                    cuotas: null,
                    montoTotal: null,
                    fechaPrimerPago: null,
                    fueraDePauta: false,
                    deudas: [],
                    cobranzas: [],
                    montoCuota: null
                }
            }
        },

        methods: {
            create() {
                if (this.$refs.form.validate()) {
                    this.loading = true
                    ConvenioProvider.createConvenio(this.form).then(r => {
                            if (r) {
                                this.$emit('itemCreated',r.data.createConvenio)
                                this.$emit('close')
                            }
                        }
                    ).catch(error => {
                         let clientError = new ClientError(error)
                         this.inputErrors = clientError.inputErrors
                         this.errorMessage = clientError.i18nMessage
                    }).finally(() => this.loading = false)
                }

            }

        },
    }
</script>

<style scoped>

</style>

